module.exports = __webpack_public_path__ + "img/downPlug.650a3887.svg";